module.exports = __webpack_public_path__ + "img/4-Howdie-Populated-Details-Page.4c223e6f.png";